import React from 'react';
import { createRoot } from 'react-dom/client';
import { onBuild, hotReloadCSS } from '#lib/helpers/esbuild.js';
import { QueryClient, QueryClientProvider } from '#lib/hooks/use-query.js';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import intl from '#lib/helpers/intl.js';
import { AppRouter } from '#routes/index.jsx';
import { Spinner } from '#lib/components/loading.jsx';
import './style.css';

const queryClient = new QueryClient();

const element = document.getElementById('root');
const root = createRoot(element);

const language = intl({
    onSetup: () => renderApp({ loadingLocale: true }),
    onSuccess: () => renderApp({ loadingLocale: false })
});

export const UserContext = React.createContext(language);

if (WATCH_MODE) onBuild(hotReloadCSS);

function App() {
    return (
        <QueryClientProvider client={queryClient}>
            <UserContext.Provider value={language}>
                <AppRouter
                    fallbackElement={
                        <div className="absolute inset-0 flex h-full items-center justify-center bg-white">
                            <Spinner />
                        </div>
                    }
                />
            </UserContext.Provider>
            <ReactQueryDevtools initialIsOpen={false} />
        </QueryClientProvider>
    );
}

export function renderApp() {
    root.render(<App />);
}

renderApp();
